class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {

    super();

    if (this.b2bCustomer()) {
      this.b2bInit();    
    }

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {    
    if (this.b2bCustomer() == false) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }else{
      this.b2bModule(event.target.dataset.index, event.target.value);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'section-cart-items',
        section: document.getElementById('section-cart-items').dataset.id,
        selector: '.b2b-counter',
      },
    ];
  }

  b2bCustomer() {
    let b2bCustomer = false;
    if ($('body').hasClass('b2b-customer')) {
      b2bCustomer = true;
    }
    return b2bCustomer;
  } 

  b2bInit() {
    let b2bCartObject = JSON.parse(localStorage.getItem('b2bCart'));
    b2bCartObject.lineItems.forEach(function (item, index) {
      $('.cart-item').eq(index).find('.quantity__input').val(item.quantity);
    });
    this.b2bModule();
    // console.log(b2bCartObject);
  }

  b2bModule(line, quantity) {
    let b2bCart = {
      discount: 0,
      lineItems: []
    }
    // this.enableLoading(line);
    let lineItem = $('#CartItem-' + line);
    let itemsCount = 0;
    let itemTotalPrice = 0;
    let itemsTotalPrice = 0;
    let itemRemoved = false;
    $('.cart-item').each(function(index) {
      itemsCount = itemsCount + parseInt($(this).find('input[name="updates[]"]').val());
      let itemVariantId = $(this).data('variant-id');
      let itemPrice = $(this).find('.cart-item__price').data('item-price');
      let itemQuantity = parseInt($(this).find('input[name="updates[]"]').val());
      let itemTotalPrice = (itemPrice * itemQuantity);      
      $(this).find('.cart-item__price').empty().html(itemTotalPrice.toFixed(2) + ' ' + Shopify.currency.active);
      itemsTotalPrice = itemsTotalPrice + itemTotalPrice;
      b2bCart.lineItems.push({ quantity: itemQuantity, id: itemVariantId });     
      if (itemQuantity == 0) {
        itemRemoved = true;
        jQuery.post(window.Shopify.routes.root + 'cart/change.js',
          {
            'line': index + 1,
            'quantity': 0
          }
        );
        $(this).remove();
        b2bCart.lineItems.splice(index, 1);
        $('.cart__line-product[data-line-index=' + (index + 1) + ']').remove();
        $('.cart__line-product-meta[data-line-index=' + (index + 1) + ']').remove();
        let cartLineIndex = 1;
        $('.cart__line-product-meta').each(function() {
          $(this).attr('data-line-index', cartLineIndex);
          $(this).prev().attr('data-line-index', cartLineIndex);
          cartLineIndex++;
        });
      }
      if (itemRemoved == false) {
        let cartLineProductMetaValues = $('.cart__line-product-meta[data-line-index=' + (index + 1) + ']').val().split('|');
        $('.cart__line-product-meta[data-line-index=' + (index + 1) + ']').attr('value', cartLineProductMetaValues[0] + ' | quantity: ' + itemQuantity);
      }                    
           
    }).promise().done(function() {
      $('.cart__items-count').empty().html(': ' + itemsCount);
      setTimeout(function() {
        $('.cart-count-bubble > span:first-child').empty().html(itemsCount);
      }, 1000);    



      let b2bTiers = $('body').data('b2b-tiers');
      let b2bDiscountRate = 0;      
      function checkB2Btiers(item, index) {
        item = item.split('|');
        if (b2bTiers[index + 1] !== undefined) {
          var nextTierGoal = b2bTiers[index + 1].split('|')[0];        
        }
        if (itemsCount >= parseInt(item[0])) {
          b2bDiscountRate = parseInt(item[1]) / 100;  
          if (b2bTiers[index + 1] !== undefined) {
            $('.cart__b2b-items-left').empty().html($('.cart__b2b-items-left').data('tier1-text').replace('{{ count }}', parseInt(nextTierGoal) - itemsCount));  
          }else{
            $('.cart__b2b-items-left').empty().html($('.cart__b2b-items-left').data('tier-max'));
          }
        }else{
          if (index === 0) {
            $('.cart__b2b-items-left').empty().html($('.cart__b2b-items-left').data('tier0-text').replace('{{ count }}', parseInt(b2bTiers[index].split('|')[0]) - itemsCount));
          }
        }
      }
      b2bTiers = b2bTiers.split(',');
      b2bTiers.forEach(checkB2Btiers); 

      

      let b2bDiscount = 1 - b2bDiscountRate;
      b2bCart.discount = b2bDiscount;
      console.log(b2bCart);
      localStorage.setItem('b2bCart', JSON.stringify(b2bCart));      
      $('.totals__subtotal-value').empty().html((itemsTotalPrice * b2bDiscount).toFixed(2) + ' ' + Shopify.currency.active);
      $('.totals__subtotal-value--b2b').empty().html((itemsTotalPrice * b2bDiscountRate).toFixed(2) + ' ' + Shopify.currency.active);
      $('.cart__line-product-total').val((itemsTotalPrice * b2bDiscount).toFixed(2) + ' ' + Shopify.currency.active);
      $('.cart__line-product-total-b2b').val((itemsTotalPrice * b2bDiscountRate).toFixed(2) + ' ' + Shopify.currency.active);
      $('.cart__line-product-discount').attr('value', (b2bDiscountRate * 100) + "%");
      let lineItemPrice = lineItem.find('.cart-item__price').data('item-price') * b2bDiscount; 
      let lineItemQuantity = lineItem.find('input[name="updates[]"]').val();
      let lineItemTotalPrice = (lineItemPrice * lineItemQuantity).toFixed(2);
      lineItem.find('.cart-item__price').empty().html(lineItemTotalPrice + ' ' + Shopify.currency.active);

      
    });



    // this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
    // this.disableLoading();
  }  

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    // TODO - check routes.cart_update_url
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach(((section) => {
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);

        const lineItem = document.getElementById(`CartItem-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        // display free shipping        
        let deliveryFrom = ($('.cart__delivery-from').data('delivery-from') * LangShopSDK.getCurrencyRate() / 100).toFixed(2).replace('.','');
        if (parsedState.original_total_price > deliveryFrom) {
          $('.cart__delivery-from-label').removeClass('active');
          $('.cart__delivery-from-success').addClass('active');
        } else {
          $('.cart__delivery-from-success').removeClass('active');
          $('.cart__delivery-from-label').addClass('active');
        }

        if (parsedState.item_count > 0) {
          $('.cart__items-count').empty().html(`: ${parsedState.item_count}`);
        } else {
          $('.cart__items-count').empty();
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value,
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
